var map = {
	"./Avatars": 31,
	"./Avatars.stories": 175,
	"./Avatars.stories.tsx": 175,
	"./Avatars.tsx": 31,
	"./NFT": 122,
	"./NFT.tsx": 122,
	"./TheAngel.png": 259,
	"./TheFounder.png": 260,
	"./TheHodler.png": 261,
	"./TheInvestor.png": 262,
	"./TheTrader.png": 263,
	"./mystery.png": 176,
	"./mystery1.png": 264,
	"./videos/ape.mp4": 265,
	"./videos/eagle.mp4": 266,
	"./videos/rhino.mp4": 267,
	"./videos/shark.mp4": 268,
	"./videos/tiger.mp4": 269,
	"./x-twitter-white.svg": 270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 255;